import * as R from 'ramda'
import moment from 'moment'
import { parsePeriod } from 'utils/stuff'

export default (transactions, properties, period) => {
	let parsedPeriod = period == 'projected' ? parsePeriod('YTM'): parsePeriod(period)

	let filteredTransactions = R.pipe(
		R.values
	  , R.filter(x => moment(x.dateTill) < moment(parsedPeriod.to))
	  , R.groupBy(R.prop('propertyID'))
	)(transactions)

	let res = R.map(x => {
		return R.reduce((sum, txn) => sum + parseInt(txn.amount), 0)(filteredTransactions[x._id] || [])
	})(properties)
	res.total = R.pipe(R.values, R.reduce((acc, next) => acc + next, 0))(res)

	return res
}



// WEBPACK FOOTER //
// ./src/helpers/kpi/badDebt.js